// Base
import DIApi from './_diApi';
// Class
class BudgetGroupItemsAPI extends DIApi {
  controllerName = 'BudgetExpenseGroupItems';
}

export default new BudgetGroupItemsAPI();
